module.exports = __webpack_public_path__ + "static/media/icon-boutons.d405371c.svg";